import { echo } from "@/echo";

echo;
// store/notifications.js
export default {
  state: {
    notifications: [],
  },
  mutations: {
    addNotification(state, notification) {
      state.notifications.push(notification);
    },
  },
  getters: {
    allNotifications(state) {
      return state.notifications;
    },
  },
  actions: {
    listenForNotifications({ commit }, userId) {
        // echo
        //   .private(`private-App.Models.User.${1}`)
        //   .listen(".hcm-notification", (event) => {
        //     console.log("Notification received:", event);
        //     // Add the notification to the store
        //     commit("addNotification", event);
        //   });
      var channel = echo.channel("notifications");
      channel.listen(".my-event", function (data) {
        console.log('notification',JSON.stringify(data));
      });
    },
  },
};
